// services/useFetchClientesProducts.ts
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import api, { withAuthenticatedRequest } from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

type ClientProduct = any // TODO: tipar corretamente

export function useFetchClientesProducts(
  id_user?: string,
  options?: Omit<
    UseQueryOptions<ClientProduct[] | null, unknown, ClientProduct[] | null, any[]>,
    'queryKey' | 'queryFn'
  >
) {
  const token = useAccessToken()

  return useQuery({
    queryKey: ['product-clients', id_user],
    enabled: Boolean(token && id_user) && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (!token || !id_user) return null
      const response = await api.get(`/products/clientsProduct/${id_user}`, withAuthenticatedRequest(token))
      const data = response?.data?.data
      return (Array.isArray(data) ? data : []) as ClientProduct[]
    },
    ...options
  })
}
